import instance from '../index';

const RES_VENDOR = 'vendor?vendor_name={vendor_name}';

export const VendorApi = {
  getData({ vendor }) {
    return instance.get(`${RES_VENDOR.replace('{vendor_name}', vendor)}`);
  }
};
